import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  appBarStyles: FelaCSS;
  backButton: FelaCSS;
  rightElement: FelaCSS;
  innerWrapper: FelaCSS;
  title: FelaCSS;
}

const styles = (hideBorder?: boolean): IStyles => ({
  appBarStyles: {
    background: colors.white,
    borderBottom: hideBorder ? 'unset' : `1px ${colors.space15} solid`,
  },
  backButton: {
    position: 'absolute',
    left: '0',
  },
  rightElement: {
    position: 'absolute',
    right: '0',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  innerWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  title: {
    display: 'block',
    textAlign: 'center',
    fontDefaultBold: 16,
    paddingHorizontal: '52px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});

export default styles;
